import { isGamesTheme } from "@utils";
import { PopupName } from "@components/popups/shared/PopupName";

export default class BlockPopupService {
	static checkIfPopupBlocked(popup: PopupName) {
		const blockedPopups = [
			PopupName.AutomaticLogout,
			PopupName.SessionExpire,
			PopupName.FavoritePopup,
			PopupName.ShowPromo,
		];

		return isGamesTheme() && blockedPopups.includes(popup);
	}
}
